'use client';

import React from 'react';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

export const TabPanel = ({ index, value, children }: TabPanelProps) => (
	<div
		className='editor-modal-tab-body'
		role='tabpanel'
		hidden={value !== index}
		id={`simple-tabpanel-${index}`}
		aria-labelledby={`simple-tab-${index}`}
	>
		{value === index && <div>{children}</div>}
	</div>
);

export const TabPage = ({ index, value, children }: TabPanelProps) => {
	return (
		<div role='tabpanel' hidden={value !== index} id={`tab-page-${index}`} aria-labelledby={`tab-page-${index}`}>
			{value === index && <div>{children}</div>}
		</div>
	);
};
